import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  eventList: true,
  photoUpload: {},
  shareModalTri: false,
};
const apiTriggerSlice = createSlice({
  name: "apiTrigger",
  initialState,
  reducers: {
    eventListTrigger: (state, action) => {
      state.eventList = !state.eventList;
    },
    photoUploadTrigger: (state, action) => {
      state.photoUpload = {
        ...state.photoUpload,
        [action.payload.id]: action.payload.value,
      };
    },
    shareModalTrigger: (state, action) => {
      state.shareModalTri = !state.shareModalTri;
    },
  },
});

export const { eventListTrigger, photoUploadTrigger, shareModalTrigger } =
  apiTriggerSlice.actions;
export default apiTriggerSlice;
